import { useDraft } from "../../../shared/context/DraftContext.js";
import styles from "../../../shared/components/shell.module.css";

/**
 * Was eine Seite zeigt, solange es weder Entwurf noch Fassung gibt.
 *
 * Das ist der Fall vor der allerersten Veröffentlichung und danach nie wieder:
 * ohne Entwurf steht auf jeder Seite die letzte Fassung, schreibgeschützt. Der
 * Knopf zum Anlegen sitzt in der Fassungsleiste, nicht hier – ein zweiter führte
 * zu der Frage, welcher der richtige ist.
 */
export function NoDraft() {
  const { loading, error } = useDraft();

  if (loading) return <p className={styles.empty}>Fassungen werden geladen …</p>;
  if (error) {
    return (
      <div className={`${styles.notice} ${styles.noticeError}`}>
        Die Fassungen konnten nicht geladen werden.
      </div>
    );
  }

  return (
    <div className={styles.card}>
      <h1 className={styles.title}>Noch keine Fassung</h1>
      <p className={styles.subtitle}>
        Es gibt noch keinen Lehrgang zum Ansehen. „Ersten Entwurf anlegen“ oben startet
        mit dem eingebauten.
      </p>
    </div>
  );
}
